import React from 'react';
import QuoteInbox from './QuoteInbox';
import Header from '../components/Header';

const CustomerMessagesPage = () => (
  <div>
    <Header />
    <QuoteInbox role="customer" />
  </div>
);

export default CustomerMessagesPage;
